<template>
  <div>
    <condition-part
      :hasCustomer="true"
      :hasFoodKind="true"
      :hasFood="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
    >
    </condition-part>
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
    };
  },
  computed: {
    columns() {
      return [
        { name: "CustomerNumber" },
        { name: "CustomerName" },
        { name: "FoodNumber" },
        { name: "FoodName" },
        { name: "Qty" },
        { name: "ExpireDate" },
      ];
    },
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getCustomerStock(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getCustomerStock(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printCustomerStock(condition);
    },
    getItems(condition) {
      const vm = this;
      this.$api.reports.getCustomerStock(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
